import { useState } from "react";
import {
  Backdrop,
  Box,
  Button,
  Grid,
  IconButton,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import { BCPXmark } from "../../../../components/icons/bcp/BCPIcons";
import { postNotification } from "../../../../components/utilities/Notifications";
import {
  getData,
  postData,
} from "../../../../components/utilities/UtilityFunctions";

export default function NonPlayingMemberModal(props) {
  const {
    teamPlayer,
    open,
    setOpen,
    setProcessing,
    nonPlayingMembers,
    setNonPlayingMembers,
  } = props;

  const [nonPlayingMember, setNonPlayingMember] = useState({ email: "" });

  if (!open) return <></>;
  return (
    <>
      <Modal
        disableAutoFocus
        open
        onClose={() => {
          setOpen(false);
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: ["95vw", "85vw", 600],
            minHeight: "95vh",
            maxHeight: "95vh",
            overflowY: "scroll",
            bgcolor: "background.paper",
            border: "1px solid rgba(0, 0, 0, 0.12)",
            borderRadius: 1,
            boxShadow: 24,
            p: 4,
          }}
        >
          <IconButton
            aria-label="cancel"
            color="error"
            sx={{ position: "absolute", top: "4px", right: "4px" }}
            onClick={() => {
              setOpen(false);
            }}
          >
            <BCPXmark />
          </IconButton>
          <Grid
            container
            spacing={2}
            sx={{
              pb: 1,
              mb: 2,
              borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
            }}
          >
            <Grid item xs={12}>
              <Typography variant="h4" component="h2">
                Coach / Assistant / Non Playing Member
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TextField
                name="email"
                label="Email"
                required
                value={nonPlayingMember?.email || ""}
                variant="outlined"
                fullWidth
                margin="normal"
                onBlur={async (e) => {
                  if (e.target.value !== "") {
                    setProcessing(true);
                    try {
                      var apiUser = await getData(`/users/${e.target.value}`, {
                        queryStringParameters: {},
                      });
                      if (apiUser) {
                        if (
                          nonPlayingMembers?.filter(
                            (el) => el.userId === apiUser.id
                          )?.length > 0
                        ) {
                          postNotification(
                            "warning",
                            "User already a non playing member"
                          );
                          setNonPlayingMember({ email: "" });
                        } else {
                          setNonPlayingMember({
                            index: nonPlayingMember?.index,
                            id: apiUser.id,
                            userId: apiUser.id,
                            email: e.target.value,
                            firstName:
                              apiUser?.firstName || apiUser?.user?.firstName,
                            lastName:
                              apiUser?.lastName || apiUser?.user?.lastName,
                          });
                        }
                      } else {
                        throw new Error("User not found");
                      }
                    } catch (err) {
                      postNotification("warning", "User not found");
                      setNonPlayingMember({ email: "" });
                    }
                    setProcessing(false);
                  } else {
                    setNonPlayingMember({ email: "" });
                  }
                }}
                onChange={(e) => {
                  setNonPlayingMember({ email: e.target.value || "" });
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                name="firstName"
                label="First Name"
                value={nonPlayingMember?.firstName || ""}
                variant="outlined"
                fullWidth
                margin="normal"
                disabled
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                name="lastName"
                label="Last Name"
                value={nonPlayingMember?.lastName || ""}
                variant="outlined"
                fullWidth
                margin="normal"
                disabled
              />
            </Grid>

            <Grid item xs={6}>
              <Button
                color="error"
                fullWidth
                variant="outlined"
                onClick={() => {
                  setOpen(false);
                }}
              >
                Cancel
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                color="success"
                fullWidth
                variant="contained"
                disabled={!nonPlayingMember?.userId}
                onClick={async () => {
                  setProcessing(true);
                  try {
                    let apiTeamPlayer = await postData(
                      `/teamplayers/${teamPlayer.id}/nonPlayingMember`,
                      {
                        body: {
                          user: nonPlayingMember,
                        },
                      }
                    );
                    setNonPlayingMembers(
                      apiTeamPlayer?.nonPlayingMembers || []
                    );
                    setOpen(false);
                  } catch (err) {
                    postNotification("error", err);
                  } finally {
                    setProcessing(false);
                  }
                }}
              >
                Add
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  );
}
